import React from 'react';

import { FormikFormControl, FormikInput } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import { t } from 'state/intl/translations';
import { spacing } from 'styles/constants';

const PhoneNumberField = ({
  hintMessage,
  isRequired = false,
  onSubmitEditing,
}: {
  hintMessage?: string | null;
  isRequired?: boolean;
  onSubmitEditing?: () => void | Promise<void>;
}) => {
  return (
    <Box style={styles.fieldContainer}>
      <FormikFormControl isRequired={isRequired} label={t('phoneNumber')} name="phoneNumber">
        <FormikInput
          inputProps={{
            placeholder: `${t('phoneNumber')}`,
            testID: 'signup-phone-input',
            placeholderTextColor: '#979797',
            autoCorrect: false,
            autoComplete: 'tel',
            keyboardType: 'phone-pad',
            returnKeyType: 'done',
            onSubmitEditing,
            // @ts-expect-error TS(2322) FIXME: Type '{ placeholder: string; testID: string; place... Remove this comment to see the full error message
            hintMessage,
          }}
        />
      </FormikFormControl>
    </Box>
  );
};

export default PhoneNumberField;

const styles = StyleSheet.create({
  fieldContainer: {
    marginBottom: spacing.$1,
  },
});
